@if (isValidandoToken) {
  <app-loader></app-loader>
} @else {
  <router-outlet></router-outlet>
}
